// app/javascript/controllers/carousel_auto_scroll_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]
  static values = {
    speed: { type: Number, default: 0.4 }
  }

  connect() {
    /* console.log("connected")
     * console.log(this.containerTarget) */
    this.x = 0
    this.isPaused = false
    this.start()

    this.element.addEventListener("mouseenter", () => this.pause())
    this.element.addEventListener("mouseleave", () => this.resume())

    this.element.addEventListener("touchstart", () => this.pause(), { passive: true })
    this.element.addEventListener("touchend", () => this.resume())
  }

  disconnect() {
    cancelAnimationFrame(this.raf)
  }

  start() {
    // console.log("start")

    const loop = () => {
      // console.log(this.x)

      if (!this.isPaused && this.hasContainerTarget) {
	this.x += this.speedValue

	const width = this.containerTarget.scrollWidth / 2

	if (this.x >= width) {
          this.x = 0
	}

	this.containerTarget.style.transform = `translateX(${-this.x}px)`
      }

      this.raf = requestAnimationFrame(loop)
    }

    this.raf = requestAnimationFrame(loop)
  }

  pause() {
    this.isPaused = true
  }

  resume() {
    this.isPaused = false
  }
}
